export default __webpack_public_path__ + "static/media/Dila's Belt.8e27c9f1.jpg";